// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__QfShV","loaderPage":"Loader_loaderPage__45I4o"};